import { Actions } from './indicateursActions';
import { Actions as UtilisateurCourantActions } from '../utilisateur/courantActions';

const initialState = {
    items: [],
    isLoading: false,
    didInvalidate: false
};

const reducer = (state = initialState, action) => {

    switch (action.type) {
        case Actions.FETCH_TYPE_INDICATEURS_REQUEST:
            return {
                ...state,
                isLoading: true,
                didInvalidate: false
            };
        case Actions.FETCH_TYPE_INDICATEURS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                didInvalidate: false,
                items: [...action.items]
            };
        case Actions.FETCH_TYPE_INDICATEURS_FAILURE:
            return {
                ...state,
                isLoading: false,
                didInvalidate: true,
                error: action.error
            };
        case Actions.INVALIDATE_TYPE_INDICATEURS:
            return {
                ...state,
                didInvalidate: true
            };

        case UtilisateurCourantActions.LOGOUT:
            return { ...initialState };

        default:
    }

    return state;
};

export default reducer;